/** Storebrand bank price list (Prisliste bank). */
export const PRICE_LIST_URL =
  'https://www.storebrand.no/privat/bank-og-lan/prisliste-bank';
